import { createContext, useContext, useState, useEffect } from 'react';
import { translations, getTranslation } from '../locales/translations';

const LanguageContext = createContext();

// Supported languages
export const LANGUAGES = [
  { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' }
];

export const LanguageProvider = ({ children }) => {
  // Get initial language from localStorage or browser
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('servicare_language');
    if (saved && LANGUAGES.find(l => l.code === saved)) {
      return saved;
    }
    // Try to detect from browser
    const browserLang = navigator.language?.split('-')[0];
    if (LANGUAGES.find(l => l.code === browserLang)) {
      return browserLang;
    }
    return 'it'; // Default to Italian
  });

  // Save language preference
  useEffect(() => {
    localStorage.setItem('servicare_language', language);
    document.documentElement.lang = language;
  }, [language]);

  // Translation helper function
  const t = (path) => {
    const keys = path.split('.');
    let obj = translations;
    
    for (const key of keys) {
      if (obj && obj[key]) {
        obj = obj[key];
      } else {
        console.warn(`Translation not found: ${path}`);
        return path;
      }
    }
    
    return getTranslation(obj, language);
  };

  // Get nested translation object
  const tObj = (path) => {
    const keys = path.split('.');
    let obj = translations;
    
    for (const key of keys) {
      if (obj && obj[key]) {
        obj = obj[key];
      } else {
        return null;
      }
    }
    
    return obj;
  };

  const value = {
    language,
    setLanguage,
    t,
    tObj,
    languages: LANGUAGES,
    getTranslation: (obj) => getTranslation(obj, language)
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
